<template>
    <footer class="py-5 rounded">
        <div class="row row-cols-1 row-cols-sm-4">
            <div class="col-12 col-sm-3">
                <h5 class="h3">{{ lang.contact }}</h5>
                <div class="small text-muted mt-2 d-flex flex-row align-content-top">
                    <i class="fas fa-phone me-2 pt-1"></i>
                    <div>
                        <div v-for="(item, index) in G.systemData?.phone?.value.split(',')" :key="index">
                            <a :href="`tel: ${item}`">{{item}}</a>
                        </div>
                        <!-- <div v-for="(item, index) in bio.phone" :key="index">{{item}}</div> -->
                    </div>
                </div>
                <div class="small text-muted mt-2 d-flex flex-row align-content-top">
                    <i class="fas fa-envelope me-2 pt-1"></i>
                    <div>
                        <div v-for="(item, index) in G.systemData?.email?.value.split(',')" :key="index">
                            <a :href="`mailto: ${item}`">{{item}}</a>
                        </div>
                    </div>
                </div>
                <!-- <p class="small text-muted">{{bio.about}}</p> -->
            </div>
            <!-- <div class="col-lg-2 col-md-6">
                <h5 class="mb-3">Info</h5>
                <ul class="list-unstyled text-muted">
                    <li class="nav-item" v-for="(item, index) in data.menu" :key="index">
                        <a class="nav-link text-uppercase" :href="item.link != '' ? item.link : '#'">{{item.title}}</a>
                    </li>
                </ul>
            </div>-->
        </div>

        <div class="row row-cols-1 row-cols-sm-2 mt-4 pt-3 border-1 border-top text-muted small">
            <div class="col">
                <p v-html="G.footerPowered"></p>
            </div>
            <div class="col d-flex">
                <ul class="list-unstyled d-flex ms-auto">
                    <li class="nav-item" v-for="(item, index) in data" :key="index">
                        <a :href="item.link" class="nav-link me-2" target="_blank">
                            <i :class="item.icon"></i>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </footer>
</template>


<script>
    import { G } from "@/_common";
    // import { data, bio } from "@/data/data";

    export default {
        name: "FooterC",
        props: ["data", "lang"],
        setup() {
            // return { G, data, bio };
            return { G };
        },
    };
</script>


<style lang="scss">
    footer {
        margin: 0px 140px;
    }
    @media (max-width: 576px) {
        footer {
            margin: unset;
        }
    }
</style>